import { gql, useQuery } from "@apollo/client";

const GET_CONGRID_USERS = gql`
  query GetCongridUsers {
    congridUsers {
      id
      firstName
      lastName
      email
    }
  }
`;

export interface CongridUser {
  id: string;
  firstName?: string | null;
  lastName?: string | null;
  email?: string | null;
}

export function useCongridUsers(skip = false) {
  const { data, loading, error } = useQuery<{ congridUsers: CongridUser[] }>(
    GET_CONGRID_USERS,
    { skip, fetchPolicy: "cache-first", nextFetchPolicy: "cache-first" },
  );
  return {
    congridUsers: data?.congridUsers ?? [],
    loading,
    error,
  };
}
